export default {
    computed: {
        allQueues() {
            return this.$store.state.queues.all
        },
        filteredQueues() {
            if (!this.data.WidgetLayout.showQueues) return []
            return this.allQueues.filter(e => this.data.WidgetLayout.showQueues.includes(e.QueueID))
        },
        queueWithActiveCalls() {
            return this.$store.getters['queues/queueWithActiveCalls'] || []
        },
        queuesToShow() {
            return this.data.WidgetLayout.showQueues
        },
        filteredQueuesWithActiveCalls() {
            if (!this.data.WidgetLayout.showQueues) return []

            if (this.queuesToShow.length) {
                return this.queueWithActiveCalls.filter(e => this.queuesToShow.includes(e.QueueID))
            } else {
                return this.queueWithActiveCalls
            }
        },
        allQueueCalls() {
            return this.$store.getters['queues/allQueueCalls'] || []
        }
    }
}
